export enum PlaybackOption {
  NEVER,
  OK_NOTES,
  ALWAYS,
}
